(function () {
  'use strict';

  // Form hooks
  // ----------------------------------------
  $( "[name='child-birthdate']" ).on( "change", function() {
    const birthdate = $(this).val();

    if ( birthdate ) {
      const date = new Date(birthdate);
      const year = date.getFullYear();
      const canDecideSooner = date.getMonth() >= 8;
      const schoolStart = year + ( canDecideSooner ? 7 : 6 );
      const schoolEntry = "September " + schoolStart;
      const schoolYear = schoolStart + "-" + ( schoolStart + 1 );

      $( ".school-year div:first" ).hide();
      $( ".school-year div:last" ).text(schoolEntry).show();
      $( "[name='school-year']" ).val(schoolYear);
      $( "[name='school-entry']" ).val(schoolEntry);

      if ( canDecideSooner ) {
        $( ".sooner-school-year" ).show();
      } else {
        $( ".sooner-school-year" ).hide();
        $( "[name='sooner-school-year']" ).prop("checked", false);
      }
    }    
  });
})();
